var _Defs, _Use, _Use2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Defs, LinearGradient, Stop, Symbol as _Symbol, Path, Use } from "react-native-svg";
function SvgCloudyWindy(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512"
  }, props), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "cloudy_windy_svg__a",
    x1: 99.45,
    y1: 30.68,
    x2: 232.64,
    y2: 261.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0,
    stopColor: "#f3f7fe"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.45,
    stopColor: "#f3f7fe"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#deeafb"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "cloudy_windy_svg__b",
    x1: 138.48,
    y1: 5.12,
    x2: 224.17,
    y2: 153.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0,
    stopColor: "#bec1c6"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.45,
    stopColor: "#bec1c6"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#959aa2"
  })), /*#__PURE__*/React.createElement(_Symbol, {
    id: "cloudy_windy_svg__c",
    viewBox: "0 0 350 222"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M291 107c-.85 0-1.68.09-2.53.13A83.9 83.9 0 00135.6 42.92 55.91 55.91 0 0051 91a56.56 56.56 0 00.8 9.08A60 60 0 0063 219c1.35 0 2.67-.11 4-.2v.2h224a56 56 0 000-112z",
    stroke: "#959aa2",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    fill: "url(#cloudy_windy_svg__a)"
  })), /*#__PURE__*/React.createElement(_Symbol, {
    id: "cloudy_windy_svg__d",
    viewBox: "0 0 348 240"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M267.16 24.29A40 40 0 11296 92H12M151.16 215.71A40 40 0 10180 148H12",
    fill: "none",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 24,
    stroke: "url(#cloudy_windy_svg__b)"
  })))), _Use || (_Use = /*#__PURE__*/React.createElement(Use, {
    width: 350,
    height: 222,
    transform: "translate(81 145)",
    xlinkHref: "#cloudy_windy_svg__c"
  })), _Use2 || (_Use2 = /*#__PURE__*/React.createElement(Use, {
    width: 129,
    height: 110,
    transform: "translate(191.5 343.5)",
    xlinkHref: "#cloudy_windy_svg__d"
  })));
}
export default SvgCloudyWindy;